export enum SupplierOrderLineColumns {
  LineNumber = 'LineNumber',
  ItemNumber = 'ItemNumber',
  ItemDescription = 'ItemDescription',
  OrderLineStatus = 'OrderLineStatus',
  ItemQuantity = 'ItemQuantity',
  SalesQuantity = 'SalesQuantity',
  RemainSalesPhysical = 'RemainSalesPhysical',
  DeliveryStatus = 'DeliveryStatus',
  LineReference = 'LineReference',
  SurchargePerPiece = 'SurchargePerPiece',
  PromisedDeliveryDate = 'PromisedDeliveryDate',
  PreferredDeliveryDate = 'PreferredDeliveryDate',
  LoanEquipment = 'LoanEquipment',
  DeliveryMode = 'DeliveryMode',
  GrossPrice = 'GrossPrice',
  NetPrice = 'NetPrice',
  LineAmount = 'LineAmount',
  SurchargeTotalAmount = 'SurchargeTotalAmount',
  SurchargeCode = 'SurchargeCode',
  SurchargeDescription = 'SurchargeDescription',
  Actions = 'actions'
}

export enum GridColumns {
  OrderId = 'Order.ID',
  OrderDate = 'Order.Date',
  OrderCustomerOrderReference = 'Order.CustomerOrderReference',
  OrderCustomerPurchaseOrderReference = 'Order.CustomerPurchaseOrderReference',
  OrderStatus = 'Order.Status',
  OrderLineDueDate = 'OrderLine.DueDate',
  SupplierOrderLineDueDate = 'SupplierOrderLine.DueDate',
  OrderLineOrderDate = 'OrderLine.OrderDate',
  OrderLineCustomerReference = 'OrderLine.CustomerReference',
  OrderLineOrderStatus = 'OrderLine.OrderStatus',
  SupplierOrderLineOrderStatus = 'SupplierOrderLine.OrderStatus',
  OrderLinePreferredDeliveryDate = 'OrderLine.PreferredDeliveryDate'
}

export interface Account {
  CompanyName?: string
  FirstName?: string
  Name?: string
  UUID?: string
}

export interface Order {
  ID?: string
  UUID?: string
  WorkOrderUUID?: string
}

export interface SupplierAllOrderRow {
  Order: SupplierAllOrder
}

export interface SupplierAllOrder {
  ID: string
  Date: string
  Status: string
  CustomerOrderReference: string
  CustomerPurchaseOrderReference: string
}

export interface OrderLine {
  CreatedAt?: string
  CreatedByName?: string
  CreatedByType?: string
  CreatedUUID?: string
  OrderUUID?: string
  CustomerReference?: string
  DeliveryMode?: string
  ItemDesc?: string
  ItemNumber?: string
  ItemQty?: number
  LoanEquipment?: string
  OrderAcctNumber?: string
  OrderDate?: string
  OrderLineNumber: number
  OrderLineReference?: string
  OrderLineStatus?: string
  OrderNumber?: string
  OrderSrc?: string
  OrderSystem?: string
  OrderType?: string
  PaymentMethod?: string
  PreferredDeliveryDate?: string
  PromisedDeliveryDate?: string
  RemainSalesPhysical?: boolean
  Remarks?: string
  SalesQty?: number
  SurchargePerPiece?: number
  UpdatedAt?: string
  UpdatedByName?: string
  UpdatedByType?: string
  UpdatedUUID?: string
  WholesalerUUID?: string
  WorkOrderID?: string
}

export interface Vehicle {
  Manufacturer?: string
  Model?: string
  Registration?: string
  Type?: string
  UUID?: string
}

export interface WorkOrder {
  AccountUUID?: string
  UUID?: string
  VehicleUUID?: string
}

export interface SupplierOrderResponseRow {
  Account: Account
  Order: Order
  OrderLine: OrderLine
  Vehicle: Vehicle
  WorkOrder: WorkOrder
}

export interface ISupplierOrderHeader {
  OrderNumber: string
  OrderUUID?: string
  CustomerName: string
  OrderDate: string
  OrderType: string
  OrderSrc: string
  CustomerReference: string
  PaymentMethod: string
  EmailAddress: string
  VehicleRegistration: string
  VehicleMake: string
  VehicleModel: string
  VehicleType: string
  Remarks: string
  ArchiveNumber: string
  SupplierName: string
  SupplierEmail: string
  WorkOrderUUID: string
  OrderStatus: string
  PreferredDeliveryDate: string
  DeliveryMethod: string
}

export interface ISupplierOrderLine {
  LineNumber: string
  ItemNumber: string
  ItemDescription: string
  OrderUUID?: string
  OrderRowUUID?: string
  OrderLineStatus: string
  ItemQuantity: number
  SalesQuantity: number
  RemainSalesPhysical: string
  DeliveryStatus: string
  LineReference: string
  SurchargePerPiece: number
  PromisedDeliveryDate: string
  PreferredDeliveryDate: string
  LoanEquipment: string
  DeliveryMode: string
  IsPlaceholder: string
  LineType: string
  SupplierProductID: string
  SupplierProductIDType: string
  OrderAccountUUID: string
}

export interface ISupplierOrderDetail {
  header: ISupplierOrderHeader
  lines: ISupplierOrderLine[]
}

export interface ISupplierOrderResponse {
  Data: ISupplierOrderDetail
}
